<template>
  <el-dialog :visible.sync="domVisible" custom-class="Questionnaire" :lock-scroll="false">
    <div class="questionnaireBox">
      <div class="onlineSupvey">
        ONLINE
        <p>SURVEY</p>
      </div>
      <img class="questionnaireTopImg" src="../../../static/images/activty/questionnaire/image_17.png">
    </div>
    <div class="questionBox">
      <el-scrollbar>
        <ul class="questionUl">
          <li v-for="(item,index) in quset" :key="index">
            <div class="answer" :class="{'on':item.status}" @click="item.status=!item.status">{{item.name}}</div>
            <div v-if="item.type&&item.status" class="input">
              <el-input />
            </div>
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <div></div>
  </el-dialog>
</template>
<script>
import qs from 'qs'
import { getInfo } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      userInfo: "",
      quset: [{
        name: 'A. Friends',
        status: false,
        type:false
      }, {
        name: 'B. Instagram',
        status: false,
        type:false
      }, {
        name: 'C. Facebook',
        status: false,
        type:false
      }, {
        name: 'D. X(Twitter)',
        status: false,
        type:false
      }, {
        name: 'E. Alt',
        status: false,
        type:false
      }, {
        name: 'F. YouTube',
        status: false,
        type:false
      }, {
        name: 'G. Offline Card Show',
        status: false,
        type:true
      }, {
        name: 'H. Other',
        status: false,
        type:true
      }]
    }
  },
  props: {
    domVisible: Boolean,
  },
  watch: {},
  filters: {},
  mounted() {},
  created() {
    this.domVisible = true
  },
  methods: {}
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.questionnaireBox {
  display: flex;
  align-items: center;
}

.questionnaireTopImg {
  height: 130px;
  margin: 0 auto;
  display: block;
}

.onlineSupvey {
  color: #fff;
  font-size: 36px;
  text-align: center;
  font-weight: 700;
  line-height: 1.1;
}

.onlineSupvey p {
  font-size: 46px;
}

.questionUl {
  height: 386px;
}
.questionUl li{
  margin: 12px 0;
}
.questionUl li>.answer {
  background: #F7F7FB;
  border-radius: 8px;
  padding: 12px 16px;
  position: relative;
  cursor: pointer;
}
.questionUl li>.answer.on{
  color: #5F6DAE;
  background: #F0F3FF;
}
.questionUl li>.answer.on::before{
  content: "";
  position: absolute;
  background: url(../../../static/images/activty/questionnaire/vector.png) no-repeat;
  background-size: contain;
  width: 22px;
  height: 16px;
    right: 16px;
}
.questionUl li>.input{
  margin-top: 12px;
}

.questionBox {
  padding: 24px 16px;
  background: #fff;
  position: relative;
  border-radius: 16px;
}

.questionBox::before {
  content: "";
  position: absolute;
  width: 386px;
  height: 35px;
  background: rgba(255, 255, 255, 0.70);
  border-radius: 16px;
  bottom: -18px;
  left: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/questionnaire.vue